module.exports = __webpack_public_path__ + "img/GALLERY-BALENO-5.f01f6b49.jpg";